import { useState } from "react";
import AppLayout from "../components/AppLayout";
import NutritionLogCard from "../components/NutritionLogCard";
import NutritionTrendChart from "../components/NutritionTrendChart";
import MentorshipStrip from "../components/MentorshipStrip";
import DailyMacroSummary from "../components/DailyMacroSummary";
import RecentAIParsesRibbon from "../components/RecentAIParsesRibbon";
import NutritionHistoryPanel from "../components/NutritionHistoryPanel";
import PhotoMealGallery from "../components/PhotoMealGallery";
import PageHero from "../components/PageHero";
import ExportRangePicker from "../components/ExportRangePicker";
import { Utensils } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function Nutrition() {
  const [refreshKey, setRefreshKey] = useState(0);
  const bumpRefresh = () => setRefreshKey((n) => n + 1);
  const { settings } = useSettings();
  // Master AI switch AND per-feature flag — hide all AI surfaces when either is off.
  const masterOn = (settings?.feature_flags?.ai_features ?? true) !== false;
  const aiEnabled = masterOn && ((settings?.feature_flags?.ai_nutrition ?? true) !== false);
  return (
    <AppLayout>
      <PageHero
        eyebrow="Fuel"
        title="Nutrition"
        subtitle="Track calories, protein, carbs, fat, sugar, fiber, and sodium alongside your protocol. Set daily targets and log meals by group to see your day at a glance."
        icon={<Utensils className="w-8 h-8 text-[#0D9488]" />}
        gradient
        actions={
          <ExportRangePicker
            pdfEndpoint="/export/nutrition.pdf"
            csvEndpoint="/export/nutrition.csv"
            pdfFilename="amino-exchange-nutrition.pdf"
            csvFilename="amino-exchange-nutrition.csv"
            testidPrefix="nutrition-export"
          />
        }
      />

      <div data-testid="nutrition-page" className="space-y-6">
        <DailyMacroSummary refreshKey={refreshKey} />
        {aiEnabled && <RecentAIParsesRibbon refreshKey={refreshKey} onRelog={bumpRefresh} />}
        {aiEnabled && <PhotoMealGallery refreshKey={refreshKey} onRelog={bumpRefresh} />}
        <NutritionLogCard onEntryChange={bumpRefresh} />
        <NutritionTrendChart />
        <NutritionHistoryPanel />
        <MentorshipStrip topic="nutrition" label="Nutrition Mentorship" />
      </div>
    </AppLayout>
  );
}
